<div class="widget container p-3" style="overflow-x: auto">
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex h-full justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    <p-table
      [columns]="selectedCols"
      [value]="statusFacade.table() ?? []"
      [scrollable]="true"
      [paginator]="true"
      [rows]="paginatorOptions.DEFAULT_ROWS"
      [rowsPerPageOptions]="paginatorOptions.ROWS_PER_PAGE"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="'common.page_report' | translate"
      class="fullTable p-3 p-datatable-sm tableHeaderAlignTop"
      paginatorPosition="bottom"
    >
      <ng-template #caption>
        <div class="flex justify-content-between align-items-end">
          <span>{{ "status.table.gates" | translate }}</span>
        </div>
      </ng-template>
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th>
              {{ col.header | translate }}
            </th>
          }
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns">
        <tr class="fixedHeightRow">
          @for (col of columns; track col) {
            @switch (col.field) {
              @case ("severity") {
                <td style="text-align: center">
                  <span class="dot" [ngClass]="rowData[col.field]"></span>
                </td>
              }
              @case ("repairStatus") {
                <td>
                  @if (!rowData.severity || rowData.severity === "OK") {
                  } @else {
                    {{
                      rowData[col.field]
                        ? ("status.repair_status" + (rowData[col.field] | repairStatus) | translate)
                        : ""
                    }}
                  }
                </td>
              }
              @case ("gateSystem") {
                <td
                  class="cursorDefault"
                  [pTooltip]="
                    gateIdentifierPipe.transform(
                      rowData.gateSystem,
                      permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)
                    )
                  "
                  tooltipPosition="left"
                >
                  {{ rowData.gateSystem.label }} ...
                </td>
              }

              @default {
                <td>
                  @if (isNumber(rowData[col.field])) {
                    <!-- Temporary solution becuase of BE Bug that return 0 for cycle in non core gates -->
                    @if (col.field === "cycle") {
                      {{ rowData[col.field] ? (rowData[col.field] | number: "" : "de") : "" }}
                    } @else {
                      {{ rowData[col.field] | number: "" : "de" }}
                    }
                  } @else {
                    {{ rowData[col.field] }}
                  }
                  @if (col.unit && rowData[col.field] !== null && rowData[col.field] !== undefined) {
                    {{ col.unit | translate }}
                  }
                </td>
              }
            }

            <!-- @if (col.field === "severity") {
                  <td style="text-align: center">
                    <span class="dot" [ngClass]="rowData[col.field]"></span>
                  </td>
                } @else {
                  <td>
                    @if (col.field === "repairStatus") {
                      @if (!rowData.severity || rowData.severity === "OK") {
                      } @else {
                        {{
                          rowData[col.field]
                            ? (rowData[col.field]
                              | repairStatus: "status.repair_status")
                            : ""
                        }}
                      }
                    } @else if (
                      rowData[col.field] !== null &&
                      rowData[col.field] !== undefined &&
                      rowData[col.field] !== ""
                    ) {
                      @if (isNumber(rowData[col.field])) {
                        {{ rowData[col.field] | number: "" : "de" }}
                      } @else {
                        {{ rowData[col.field] }}
                      }
                      @if (col.unit) {
                        {{ col.unit | translate }}
                      }
                    }
                  </td>
                } -->
          }
          <td>
            @if (
              (rowData.severity === "MAJOR" || rowData.severity === "CRITICAL") &&
              (rowData.repairStatus === REPAIR_STATUS.None ||
                rowData.repairStatus === REPAIR_STATUS.Archived ||
                rowData.repairStatus === null)
            ) {
              <app-svg-icon
                *appHasPermission="{
                  permissions: [permissions.allPermissions.DASHBOARD_READ],
                  missingPermission: permissions.allPermissions.REPAIR_REQUEST_CREATE,
                }"
                iconName="eye"
                iconColor="primary"
                class="pointer"
                (click)="openRepairModal(rowData, 'details')"
              ></app-svg-icon>
              <app-svg-icon
                *appHasPermission="{
                  permissions: [permissions.allPermissions.REPAIR_REQUEST_CREATE],
                }"
                iconName="repair"
                iconColor="primary"
                class="pointer"
                (click)="openRepairModal(rowData, 'request')"
              ></app-svg-icon>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
